<template>
  <div id="app">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&family=Outfit:wght@300;500;700&display=swap" rel="stylesheet">
    <LoadingScreen v-if="isLoading" />
    <router-view v-else />
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue'
import LoadingScreen from './components/LoadingScreen.vue'

export default {
  name: 'App',
  components: {
    Footer,
    LoadingScreen
  },
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    // Simula carregamento real (exemplo: aguarde assets, API, etc)
    setTimeout(() => {
      this.isLoading = false
    }, 1200)
  }
}
</script>

<style lang="scss">
@import './assets/styles/main.scss';
</style>